import { ActionButtonsContainer, Button, ContentSection } from "@vwfs-bronson/bronson-react";
import { dataModels } from "../../data/dataModels";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ContinueLater, continueLaterLocalization } from "@vwfs-its/sf-sac-frontend";
import SaveAndContinueService from "../../services/SaveAndContinueService";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { ISaveForLaterRequest } from "../../interfaces";

export const SaveAndContinue = () => {
    const { t, i18n } = useTranslation("sac");
    const [showContinueLater, setShowContinueLater] = React.useState(false);
    const [, setCloseTabWarning] = React.useState(false);
    const { submitAnswersRequest, setIsLoading } = useMatchMakerWizard();

    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    // Calculate date 30 days from now and format it as DD.MM.YYYY
    const getExpirationDate = () => {
        const date = new Date();
        date.setDate(date.getDate() + 30);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    React.useEffect(() => {
        const localization = continueLaterLocalization({
            locale: "it",
            brandName: brand,
            dataProtectionLink: "https://www.vwfs.it/privacy-policy/vwl.html",
        });
        i18n.addResourceBundle("it", "sf-sac", localization, true, true);
    });

    const handleSaveAndContinue = useCallback(
        async (values: any, setShowMailDispatched: (arg0: boolean) => void) => {
            setIsLoading(true);
            try {
                console.log("values", values);
                const answersServices = new SaveAndContinueService();
                await answersServices.saveAndContinue({
                    ...submitAnswersRequest,
                    agreeTermsAndConditionsCheck: values.continueLaterDataProtection,
                    email: values.continueLaterEmail,
                    phoneCountryCode: values.continueLaterPhoneCountryCode,
                    phoneNumber: values.continueLaterPhone,
                } as ISaveForLaterRequest);
                setShowMailDispatched(true);
            } catch (error) {
                setShowContinueLater(true);
            } finally {
                setIsLoading(false);
            }
        },
        [submitAnswersRequest, setIsLoading]
    );

    return (
        <>
            <ActionButtonsContainer labelCollapsed={t("tooltip")} labelExpanded={t("tooltip")}>
                <Button
                    incognito
                    icon="semantic-save-local"
                    testId="continueLaterFloatingButton"
                    onClick={() => {
                        setShowContinueLater(true);
                    }}
                >
                    {t("tooltip")}
                </Button>
            </ActionButtonsContainer>
            <ContentSection.ComponentWrapper>
                <ContinueLater
                    version={1}
                    phoneCountryCode={"+39"}
                    disableMandatoryAsterisk
                    dataProtection={false}
                    dataModels={dataModels}
                    testId="continueLaterModal"
                    showModal={{
                        showContinueLater,
                        setShowContinueLater,
                        setCloseTabWarning,
                    }}
                    onShow={""}
                    onCancel={() => {
                        setShowContinueLater(false);
                        setCloseTabWarning(false);
                    }}
                    linkValidityText={`${getExpirationDate()}`}
                    onContinueLaterSubmit={(
                        values: any,
                        showModal: any,
                        setShowMailDispatched: (arg0: boolean) => void
                    ) => {
                        setShowContinueLater(false);
                        handleSaveAndContinue(values, setShowMailDispatched);
                    }}
                />
            </ContentSection.ComponentWrapper>
        </>
    );
};
